module.exports = __webpack_public_path__ + "img/vanessa.242605a5.jpeg";